import { render } from "./SortTableMobileFirstColumnComponent.vue?vue&type=template&id=50281051&scoped=true"
import script from "./SortTableMobileFirstColumnComponent.vue?vue&type=script&lang=js"
export * from "./SortTableMobileFirstColumnComponent.vue?vue&type=script&lang=js"

import "./SortTableMobileFirstColumnComponent.vue?vue&type=style&index=0&id=50281051&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50281051"]])

export default __exports__